<template>
  <v-dialog max-width="1000" v-model="dialog" scrollable v-if="dialog">
    <v-card class="proforma-invoice-show-detail-line">

      <v-card-title>
        {{ $t('proforma-invoice.line-details') }}
      </v-card-title>
      <v-divider class="mb-8" />

      <v-card-text>
        <v-row>
          <v-col>
            <v-data-table
              :items="proformaInvoiceLines"
              :headers="headers"
            >
              <template #item.linkType="{item}">
                <span class="text-uppercase">{{ item.linkType }}</span>
              </template>
              <template #item.price="{item}">
                {{ numberFormat(item.price, 2) }} €
              </template>
              <template #item.data="{item}">
                <template v-if="item.linkType === 'cdr'">
                  <div>CdrId : <b>{{ item.cdrId }}</b> <v-btn small icon @click="copyToClipboard(item.cdrId)"><v-icon small>mdi-content-copy</v-icon></v-btn></div>
                  <div>Token : <b>{{ item.tokenUid }}</b> <v-btn small icon @click="copyToClipboard(item.tokenUid)"><v-icon small>mdi-content-copy</v-icon></v-btn></div>
                </template>
                <template v-if="item.linkType === 'licence'">
                  <div>SubscriptionId : <b>{{ item.subscriptionId }}</b> <v-btn small icon @click="copyToClipboard(item.subscriptionId)"><v-icon small>mdi-content-copy</v-icon></v-btn></div>
                  <div>Device : {{ item.data.related.identifier }} <v-btn v-if="item.data.related.identifier" small icon @click="copyToClipboard(item.data.related.identifier)"><v-icon small>mdi-content-copy</v-icon></v-btn> ({{ item.data.related.type }}) : {{ item.data.related.name }}</div>
                </template>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-row dense class="ma-0">
          <v-col class="text-right">
            <v-btn small class="primary" @click="dialog = false" type="button">
              {{ $t('close') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ProformaInvoiceRepository from "@repository/ProformaInvoiceRepository";

export default {

  data() {
    return {
      dialog: false,
      proformaInvoiceLines: [],
    }
  },

  watch: {

  },

  computed: {
    headers() {
      return [
        {text: this.$t('type'), value: 'linkType', width: 120},
        {text: this.$t('quantity'), value: 'quantity', width: 120},
        {text: this.$t('price'), value: 'price', width: 120},
        {value: 'data', align: 'left'},
      ]
    },
  },


  methods: {

    open(proformaInvoiceId, proformaInvoiceLineId) {
      this.proformaInvoiceId = proformaInvoiceId
      this.proformaInvoiceLineId = proformaInvoiceLineId
      this.showLoading(true)
      this.loadData().then(() => {
        this.dialog = true
      })
    },

    loadData() {
      return new Promise((resolve, reject) => {
        this.showLoading(true)
        ProformaInvoiceRepository.itemLinks(this.proformaInvoiceId, this.proformaInvoiceLineId).then(data => {
          this.proformaInvoiceLines = data
          this.showLoading(false)
          resolve(data)
        }).catch(error => {
          this.notifyError(error)
          this.showLoading(false)
        })
      })
    },
  }
}
</script>

<style lang="scss">
.proforma-invoice-show-detail-line {
  .proforma-invoice-number {
    font-size:20px;
    font-weight: bold;
  }

  .proforma-invoice-address {
    min-width: 400px;
  }

  .v-data-table {
    tr {
      &:hover {
        background-color: transparent !important;
      }
      th {
        border-top: 1px solid #e0e0e0 !important;
        border-left: 1px solid #e0e0e0 !important;
        &:last-child {
          border-right: 1px solid #e0e0e0 !important;
        }
      }
      td {
        border-top: 1px solid #e0e0e0 !important;
        border-left: 1px solid #e0e0e0 !important;
        height: 30px !important;
        &.proforma-invoice-line-type {
          text-align: center;
          background: #eee;
        }
        &.no-border {
          border-left: 0 !important;
        }
        &:last-child {
          border-right: 1px solid #e0e0e0 !important;
        }
      }
      &:last-child {
        td:not(.no-border) {
          border-bottom: 1px solid #e0e0e0 !important;
        }
      }
    }
  }
}
</style>
